<template>
  <main>
    <div class="add-service">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.addService") }}</h3>
            </template>

            <template v-slot:right-element>
              <router-link
                :to="{ name: 'ServiceList' }"
                class="btn btn-outline-primary button"
                :disabled="loading"
              >
                <i class="arrow left"></i>
                {{ $t("button.retour") }}
              </router-link>
            </template>
          </TopTemplate>
          <div v-if="is_created" class="alert alert-success" role="alert">
            {{ $t("info.succesService") }}
          </div>
          <div v-if="messageError" class="alert alert-danger" role="alert">
            {{ $t("error.existService") }}
          </div>
          <div class="ajout-container message-add">
            <form novalidate @submit.prevent="onSubmitCreateService">
              <div class="row">
                <div class="col-md-6 p-3" ref="simpleselect">
                  <div class="ajout-container__simple">
                    <label>{{ $t("service.form.name") }}<sup>*</sup></label>
                    <input
                      v-model="service.name"
                      type="text"
                      :reduce="(option) => option.id"
                      class="form-control p-2"
                      :class="v$.service.name.$error ? 'is-invalid' : ''"
                    />
                    <span
                      class="invalid-feedback"
                      v-if="v$.service.name.$error"
                    >
                      {{ v$.service.name.$errors[0].$message }}
                    </span>
                  </div>
                </div>

                <div class="col-md-6 p-3">
                  <div class="ajout-container__simple">
                    <label>{{ $t("service.form.date") }}<sup>*</sup></label>

                    <div class="input-date">
                      <Datepicker
                        v-model="service.date_start"
                        :enableTimePicker="false"
                        autoApply
                        locale="fr"
                        :format="format_date_v1"
                        :min-date="new Date()"
                        @update:modelValue="formatByDate"
                        class="form-control"
                        :class="
                          v$.service.date_start.$error ? 'is-invalid' : ''
                        "
                      />
                      <span
                        v-if="v$.service.date_start.$error"
                        class="invalid-feedback"
                      >
                        {{ v$.service.date_start.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
                <br />
                <div class="col-12 p-3">
                  <div class="ajout-container__multiple">
                    <div class="ajout-container__simple">
                      <label
                        >{{ $t("service.description") }} <sup>*</sup></label
                      >
                    </div>
                    <textarea
                      class="form-control p-2"
                      :class="v$.service.description.$error ? 'is-invalid' : ''"
                      v-model="service.description"
                      maxlength="300"
                    />
                    <span
                      class="invalid-feedback"
                      v-if="v$.service.description.$error"
                    >
                      {{ v$.service.description.$errors[0].$message }}
                    </span>
                    <label class="indice">{{ $t("info.sizeText") }}</label>
                  </div>
                </div>
                <div class="col-12 p-3">
                  <div class="ajout-container__simple">
                    <label>{{ $t("service.form.mois") }}<sup>*</sup></label>
                    <div class="row items-wrapper">
                      <div class="row items-wrapper">
                        <div
                          v-for="(mois, index) in listMois"
                          :key="mois.index"
                          class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-xs-12 pointer"
                          @click="
                            checkItem(mois.status),
                              (mois.is_checked = !mois.is_checked)
                          "
                        >
                          <div
                            class="matiere-item"
                            :class="
                              mois.is_checked === true
                                ? 'matiere-background'
                                : ''
                            "
                          >
                            <span>{{ mois.name }}</span>
                            <label class="container-checkbox mois-service">
                              <input
                                v-model="mois.status"
                                type="checkbox"
                                :value="mois.status"
                              />
                              <span
                                class="checkmark"
                                :class="
                                  mois.is_checked === true ? 'chekedchek' : ''
                                "
                              ></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 button-envoyer text-right">
                  <button
                    type="submit"
                    class="btn button btn-primary"
                    :disabled="loading"
                  >
                    <i class="icon-Check"></i>
                    {{ $t("button.envoi") }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
  
  <script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import Form from "../../core/Form";
import useValidate from "@vuelidate/core";
import { required, maxLength, helpers } from "@vuelidate/validators";
import vSelect from "vue-select";
import ServicesService from "../../services/services.service";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import _ from "lodash";
import { ref } from "vue";
export default {
  name: "AddService",
  components: {
    TopTemplate,
    "v-select": vSelect,
    Datepicker,
  },
  setup() {
    // In case of a range picker, you'll receive [Date, Date]
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/${month}/${year}`;
      } else if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };
    const flow = ref(["year", "calendar"]);
    return {
      format,
      flow,
    };
  },
  data() {
    return {
      v$: useValidate(),
      listMois: [
        {
          name: "Janvier",
          status: 0,
          is_checked: false,
        },
        {
          name: "Février",
          status: 0,
          is_checked: false,
        },
        {
          name: "Mars",
          status: 0,
          is_checked: false,
        },
        {
          name: "Avril",
          status: 0,
          is_checked: false,
        },
        {
          name: "Mai",
          status: 0,
          is_checked: false,
        },
        {
          name: "Juin",
          status: 0,
          is_checked: false,
        },
        {
          name: "Juillet",
          status: 0,
          is_checked: false,
        },
        {
          name: "Août",
          status: 0,
          is_checked: false,
        },
        {
          name: "Septembre",
          status: 0,
          is_checked: false,
        },
        {
          name: "October",
          status: 0,
          is_checked: false,
        },
        {
          name: "November",
          status: 0,
          is_checked: false,
        },
        {
          name: "Décembre",
          status: 0,
          is_checked: false,
        },
      ],
      checked: false,
      service: new Form({
        name: "",
        description: null,
        price: 0,
        date_start: null,
        months: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        // is_active: [0,0,1,0,0,0,0,0,0,0,0,0]
      }),
      selected: [],
      is_created: false,
      loading: false,
      requiredDescriptionLength: 300,
      messageError: false,
    };
  },

  validations() {
    return {
      service: {
        name: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },
        date_start: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
        },

        description: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
          maxLength: maxLength(this.requiredDescriptionLength),
        },
      },
      /*  months : {
          required: helpers.withMessage(
              this.$t("validation.required"),
              required
            ),
        } */
    };
  },

  mounted() {},

  methods: {
    format_date_v1(value) {
      if (value) {
        return moment(String(value)).format("DD-MM-YYYY");
      }
    },
    checkItem(id) {
      if (this.selected.includes(id)) {
        this.selected = this.selected.filter((el) => el != id);
      } else {
        this.selected.push(id);
      }
    },
    formatByDate: _.debounce(function () {
      if (this.service.date_start != null) {
        this.service.date_start = this.dateTime(this.service.date_start);
      }
    }, 200),
    onSubmitCreateService() {
      this.loading = true;
      this.v$.$validate();
      this.selected = [];
      this.listMois.forEach((element) => {
        if (element.is_checked === false) {
          element.status = 0;
        } else {
          element.status = 1;
        }
      });
      this.listMois.forEach((element) => {
        this.selected.push(element.status);
      });
      if (!this.v$.$error) {
        const data = {
          name: this.service.name,
          description: this.service.description,
          date_start: this.service.date_start,
          months: this.selected,
          price: 0,
        };

        ServicesService.create(data)
          .then((response) => {
            this.messageError = false;
            this.is_created = true;
            this.loading = false;
            this.scrollToTop();
            this.$router.push({ name: "ServiceList" });
          })
          .then(() => {
            this.$nextTick(() => {
              this.resetForm();
              this.service.reset();
              setTimeout(() => {
                this.v$.$reset();
              }, 0);
            });
          })
          .catch((error) => {
            this.messageError = error.response.data.errors.name ? true : false;
            this.is_created = false;
            this.loading = false;
          });
      }
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    resetForm() {
      this.service.name = "";
      this.service.description = "";
      this.service.price = "";
      this.service.date_start = "";
      this.service.months = "";
      this.selected = "";
    },
  },
};
</script>
  